export const locale = {
  lang: 'en',
  multiselect_groups : {
    'USERS_GROUPS': 'Grupos'
  }
};
